import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestNotePhraseEdit from './request/requestNotePhraseEdit'
import requestNotePhraseRegister from './request/requestNotePhraseRegister'

const Actions = {
  // NP01 備考定型文一覧取得
  getNotePhraseListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.NOTE_PHRASE_LIST)
      .get(api.NOTE_PHRASE_LIST)
      .then((response) => {
        const path = mutationsTypes.NOTE_PHRASE_SET_NOTE_PHRASE_LIST
        commit(path, response.data.data)
        const getData = getters.getNotePhraseListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // NP02 備考定型文登録
  registerNotePhrase: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestNotePhraseRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.NOTE_PHRASE_REGISTER_EDIT)
      .post(api.NOTE_PHRASE_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // NP03 備考定型文編集
  editNotePhrase: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestNotePhraseEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.NOTE_PHRASE_REGISTER_EDIT)
      .patch(`${api.NOTE_PHRASE_REGISTER_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // NP04 備考定型文削除
  deleteNotePhrase: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      // .get(apiMock.NOTE_PHRASE_DELETE)
      .patch(`${api.NOTE_PHRASE_DELETE}/${params.id}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
